import logoutService from '../commomServices/logoutService'

export const logoutMethod = {
  async logoff() {
    await logoutService.getLogout()

    localStorage.removeItem('pcm_access_token')
    localStorage.removeItem('pcm_permissions')

    this.$router.push({ name: 'login' })
  },
}
